import React from 'react'

function TermsPage() {
  return (
    <div>
    <div className='flex justify-center items-center'>
        <h2 className='text-3xl font-bold mt-6 m-4'> 
          Football Quiz Terms and Conditions
        </h2>
        </div>
        <div className='lg:p-8 lg:m-8 p-4 m-4 flex justify-center items-center'>
     <p>
    

     <strong>1.	Introduction</strong><br/>
2.	1.1 Football Quiz is a game where subscribers answer football questions correctly to earn points and qualify for daily and monthly draws and stand a chance to win a trip to watch the EPL finals, cash and airtime. 
The minimum point to qualify for a draw is 10 points. All users qualify for the daily draw automatically because all users get 10 points on subscription and renewal daily. Subscription prices 
are N100/day and N200/week, users can play multiple times for an on demand subscription of N50 per game. 
By 6 pm each day, entries close and a draw is held, any entry after 6 pm will be considered for the following day.<br/><br/>

3.	3.1 Service is available to all MTN Nigeria customers with a valid mobile number (“Player/s”).Subscribing<br/><br/>
4.1 Players must subscribe to the Service by either SMS(by texting FQD or FQW to 20782),.<br/><br/>

<strong>Winner Determination</strong><br/>
4.2 Daily winners are selected via computer/machine draw for the grand prize and daily prizes.<br/><br/>

<strong>Unsubscribing:</strong><br/>
4.5 Players can unsubscribe via SMS, users simply text:<br/>
- Stop FQD to 20782(daily)<br/>
- Stop FQW to 20782(weekly)<br/>
4.6 Players will receive an SMS confirming that they have been unsubscribed from the service. <br/>
4.7 If they unsubscribe from the service, they are not eligible for the draws and the prizes.,<br/><br/>
<strong>5. Prizes</strong><br/>
5.1 Winners stand a chance to win the following prizes: <br/><br/>
<div className='border-2 border-black lg:w-[400px]'>
<strong className='flex justify-center items-center border-b-2 border-black'>DAILY PRIZES</strong><br/>
<p className='border-b-2 border-black'>A trip to watch EPL or Cash Equivalent</p><br/>
<p className='border-b-2 border-black'>Cash Prizes (N1000,000)</p><br/>
<p className=''>Airtime</p><br/>
</div><br/>

<strong>6. General</strong><br/>
6.1 Winners of cash prizes will be notified the following day via SMS to send in their bank details with the corresponding mobile number they played with to claim their prize.<br/>
6.2 Cash prize winners will be credited via MTN MoMo. .<br/>
6.3 The grand prize winner(s) bound for a trip to watch the EPL finals live, must have a valid international passport valid for a minimum of six(6) months, if otherwise, the winner(s) is/are disqualified from the trip, and another winner(s) will be selected.<br/>
6.4 Airtime winners get credited automatically.<br/>
6.5 All subscribers on subscription get 10 points, same with the subscribers on renewals. For weekly subscribers, such subscribers get 10 points daily, and qualify for the daily draw.<br/>
6.6 The Service begins immediately after the user subscribes.<br/>
6.7EMT reserves the right, at any time, to change these Terms and Conditions and any rules relating to its products and the Service, and to modify the Services at its discretion.<br/>
6.8 EMT reserves the right from time to time to vary the charges of the Service as may be deemed necessary in its discretion.<br/>
6.9 EMT shall be entitled to terminate the Service of any Customer, if such Customer is involved in any fraudulent activity or suspected fraudulent activity.<br/>


 
    </p> 
    </div>
    </div>
  )
}

export default TermsPage
